module.exports = "<div class=\"dpp-info-dialog d-flex flex-column\" ng-if=\"ctrl.resolve\">\n    <div class=\"dpp-info-dialog-header\" ng-bind=\"ctrl.resolve.title\"></div>\n    <div class=\"dpp-info-dialog-content\" ng-bind=\"ctrl.resolve.message\"></div>\n    <div class=\"dpp-info-dialog-footer d-flex justify-content-end\">\n        <button translate=\"ok\" class=\"btn\" ng-click=\"ctrl.onClose()\"></button>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/products/components/dpp-info-dialog/dpp-info-dialog.component.html
// module id = 821
// module chunks = 0